import React from 'react';
import { Badge } from 'react-bootstrap';
import {
  SEGMENTOS_OPCOES,
  ESTAGIOS_OPCOES,
} from '../validationSchemas';

// Substitui a string CR-separada do Delphi (RN-08) por chips legíveis.
// Cada chip recebe key estável derivada do tipo+valor (LICOES §1.5).
const Chip = ({ children }) => (
  <Badge
    pill
    variant="info"
    className="mr-1 mb-1 py-1 px-2"
    style={{ fontSize: '0.75rem', fontWeight: 500 }}
  >
    {children}
  </Badge>
);

const ChipsFiltros = ({ filtros }) => {
  if (!filtros) return null;

  const chips = [];

  if (filtros.codigoGrupoEmpresa) {
    chips.push({
      key: `ge-${filtros.codigoGrupoEmpresa}`,
      texto: `GE: ${filtros.codigoGrupoEmpresa}`,
    });
  }
  if (filtros.codigoGrupoGe) {
    chips.push({
      key: `ggge-${filtros.codigoGrupoGe}`,
      texto: `Grupo de GE: ${filtros.codigoGrupoGe}`,
    });
  }
  if (filtros.codigoFamilia) {
    chips.push({
      key: `fam-${filtros.codigoFamilia}`,
      texto: `Empreendimento: ${filtros.codigoFamilia}`,
    });
  }

  const labelsSegmentos = (filtros.segmentos || [])
    .map((v) => (SEGMENTOS_OPCOES.find((o) => o.value === v) || {}).label)
    .filter(Boolean);
  if (labelsSegmentos.length > 0) {
    chips.push({
      key: 'segmentos',
      texto: `Segmentos: ${labelsSegmentos.join(', ')}`,
    });
  }

  const labelsEstagios = (filtros.estagios || [])
    .map((v) => (ESTAGIOS_OPCOES.find((o) => o.value === v) || {}).label)
    .filter(Boolean);
  if (labelsEstagios.length > 0) {
    chips.push({
      key: 'estagios',
      texto: `Estágios: ${labelsEstagios.join(', ')}`,
    });
  }

  return (
    <div className="d-flex flex-wrap align-items-center">
      <span className="small text-muted mr-2 mb-1">Filtros aplicados:</span>
      {chips.length === 0 ? (
        <span className="small text-muted mb-1">(nenhum)</span>
      ) : (
        chips.map((c) => <Chip key={c.key}>{c.texto}</Chip>)
      )}
    </div>
  );
};

export default ChipsFiltros;
